export default function serviceWorker() {
    let serviceWorkerUrl = `${process.env.PUBLIC_URL}/serviceWorker.js`;
    navigator.serviceWorker.register(serviceWorkerUrl).then((response) => {
        console.warn("response", response);
    });
}
